import { useCallback } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// FUNCTIONS
import { modalFunctions, makePath, fileDownload, documentFetch } from 'functions.js';

// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite';

const useConfirmRevive = ({ customerName, stockNum }) => {
  const handleRevive = useCallback(
    newSalesId => {
      modalFunctions.add({
        type: 'confirmation',
        title: 'Sale Confirmation',
        body: (
          <div className="d-flex">
            <Sprite use="check-circle" fill="success" className="me-2" />
            <span className="flex-grow-1">This sale has been successfully added.</span>
          </div>
        ),
        cancelButton: {
          col: { xs: { span: 24, order: 2 }, lg: { span: 8, order: 1 } }
        },
        continueButton: {
          label: 'Print Gross Recap and Clean-Up Form',
          icon: 'print',
          onClick: () => {
            const args = {
              endpoint: makePath(ENDPOINTS.sales.print.recap, newSalesId),
              params: {
                recapType: 'Gross',
                printCleanUpForm: 1
              },
              accept: 'pdf',
              contentType: 'pdf',
              mimeType: 'application/pdf',
              loadingMessage: 'Downloading Gross Recap and Clean-Up Form',
              errorMessage: 'Unable to download Gross Recap and Clean-Up Form',
              successMessage: 'Gross Recap and Clean-Up Form downloaded.',
              onSuccess: ({ url }) => {
                fileDownload(url, `${stockNum}_${customerName}_gross_recap_cleanup`, 'pdf', true, false);
              }
            };
            documentFetch(args);
          },
          col: { xs: { span: 24, order: 1 }, lg: { span: 16, order: 2 } },
          className: 'mb-4 mb-lg-0'
        },
        spacing: 'sm'
      });
    },
    [customerName, stockNum]
  );

  return handleRevive;
};

export default useConfirmRevive;
